module.exports = __webpack_public_path__ + "static/media/heart-care.da9193e1.svg";